import React from 'react';
import _ResponsiveContentCarousel from 'src/components/Modules/ResponsiveContentCarousel';

import { compose } from 'redux';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import ContentGroupHOC from '../HOC';
const ResponsiveContentCarousel = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnAdd,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
    extraProps,
  } = props || {};

  const { breakpoint } = extraProps;
  const isConvertible = EPreviewSize.WIDE !== breakpoint;
  const { options, animations, hoverAnimations, buttons } = React.useContext(
    ContentModuleGroupPreloadingContext,
  );
  // const inUsePages = get(options, 'inUsePages') || [];
  // const pendingPages = get(options, 'pendingPages') || [];
  // const previousPages = get(options, 'previousPages') || [];
  // const contentPages = [...inUsePages, ...pendingPages, ...previousPages];

  return (
    <_ResponsiveContentCarousel
      isConvertible={isConvertible}
      contentPageList={options}
      staticData={staticData}
      contentPages={dynamicData}
      onItemDelete={handleOnItemDelete}
      onItemAdd={handleItemOnAdd}
      onItemChange={handleItemOnChange}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      linkSet={linkSet}
      specificError={specificError}
      droppableId={droppableId}
      animations={animations}
      hoverAnimations={hoverAnimations}
      buttons={buttons}
    />
  );
};
export default compose(ContentGroupHOC)(ResponsiveContentCarousel);
